export default __webpack_public_path__ + "static/media/R10.5dfb6793.png";